export const Csv = ({
  size = "20",
  ...props
}: { size?: string } & React.SVGProps<SVGSVGElement>) => {
  return (
    <>
      <span className="t-sr-only">Csv</span>
      <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M13.4375 13.125L15 16.875L16.5625 13.125"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.25 16.4453C5.95098 16.7187 5.56138 16.8717 5.15625 16.875C4.20313 16.875 3.4375 16.0391 3.4375 15C3.4375 13.9609 4.20313 13.125 5.15625 13.125C5.56138 13.1283 5.95098 13.2813 6.25 13.5547"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.75 16.5625C9.0886 16.8151 9.49946 16.952 9.92188 16.9531C10.625 16.9531 11.25 16.7188 11.25 15.9375C11.25 14.6875 8.75 15.2344 8.75 14.0625C8.75 13.4375 9.21875 13.0469 9.92188 13.0469C10.3443 13.048 10.7551 13.1849 11.0938 13.4375"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.75 10V3.125C3.75 2.95924 3.81585 2.80027 3.93306 2.68306C4.05027 2.56585 4.20924 2.5 4.375 2.5H11.875L16.25 6.875V10"
          fill="#B1E6AC"
        />
        <path d="M11.875 2.5V6.875H16.25" fill="#509D65" />
      </svg>
    </>
  );
};
